import React, { Component, Fragment } from 'react';
import {
	IMfaSetupProps,
	IMfaSetupState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import Row from './styledComponents/Row';
import MfaMethodWrapper from './styledComponents/MfaMethodWrapper';
import ActiveMfaMethodWrapper from './styledComponents/ActiveMfaMethodWrapper';
import RowText from './styledComponents/RowText';
import RowButtonWrapper from './styledComponents/RowButtonWrapper';
import ClickText from './styledComponents/ClickText';
import { computed } from 'mobx';
import { MfaSetupPush } from '../MfaSetupPush/MfaSetupPush';
import { MfaSetupText } from '../MfaSetupText/MfaSetupText';
import { MfaSetupCall } from '../MfaSetupCall/MfaSetupCall';
import { MfaStep } from './models/MfaStep';
import ConfirmDialog from '@kurtosys/ksys-app-components/dist/components/base/ConfirmDialog';
import Checkbox from '@kurtosys/ksys-app-components/dist/components/base/Checkbox';
import { MfaMethods } from './models/MfaMethods';
import { ActionTiles } from '../App/models/ActionTiles';

@inject('appStore', 'mfaSetupStore')
@observer
export class MfaSetup extends Component<IMfaSetupProps, IMfaSetupState> {
	static configurationKey: 'mfaSetup' = 'mfaSetup';
	static styleKey: 'mfaSetup' = 'mfaSetup';
	constructor(props: IMfaSetupProps) {
		super(props);
	}

	@computed
	get mfaCheckboxRows() {
		const { mfaSetupStore } = this.props;
		const mfaCheckboxRows = mfaSetupStore && mfaSetupStore.mfaCheckboxRows;

		if (!mfaCheckboxRows) {
			return null;
		}

		return (
			<Fragment>
				{
					mfaCheckboxRows.map((row, index) => {
						const { label, onChange, checked, method, activeRow } = row;
						if (activeRow) {
							return (
								<ActiveMfaMethodWrapper key={ `row_${ index }` }>
									<Checkbox label={ label } onChange={ onChange } value={ true } />
									{ method === MfaMethods.push && <MfaSetupPush /> }
									{ method === MfaMethods.text && <MfaSetupText /> }
									{ method === MfaMethods.call && <MfaSetupCall /> }

								</ActiveMfaMethodWrapper>
							);
						}
						return (
							<MfaMethodWrapper key={ `row_${ index }` }>
								<Checkbox label={ label } onChange={ onChange } value={ checked } />
							</MfaMethodWrapper>
						);
					})
				}
			</Fragment>
		);
	}

	@computed
	get mfaRows() {
		const { mfaSetupStore } = this.props;
		const mfaDrilldownRows = mfaSetupStore && mfaSetupStore.mfaDrilldownRows;

		if (!mfaDrilldownRows) {
			return null;
		}

		return (
			<Fragment>
				{
					mfaDrilldownRows.map((row, index) => (
						<Row key={ `row_${ index }` }>
							<RowText>
								{ row.label }
							</RowText>
							<RowButtonWrapper>
								<ClickText onClick={ row.onClick }>{ row.buttonText }</ClickText>
							</RowButtonWrapper>
						</Row>
					))
				}
			</Fragment>
		);
	}

	render() {
		const { className, mfaSetupStore, appStore } = this.props;

		if (!mfaSetupStore || !appStore) {
			return null;
		}

		if (!appStore.isActionEnabled(ActionTiles.MFA_SETUP)) {
			return null;
		}

		const { mfaSetupCardProps } = appStore;
		const { step, confirmDialogProps, showConfirmDialog, displayType } = mfaSetupStore;

		return (
			<Wrapper className={ className } { ...mfaSetupCardProps }>
				{
					displayType === 'drilldown' && (
						<Fragment>
							{ step === MfaStep.default && this.mfaRows }
							{ step === MfaStep.pushSetup && <MfaSetupPush /> }
							{ step === MfaStep.textSetup && <MfaSetupText /> }
							{ step === MfaStep.callSetup && <MfaSetupCall /> }
						</Fragment>
					)
				}
				{
					displayType === 'checkbox' && this.mfaCheckboxRows
				}
				{ showConfirmDialog && confirmDialogProps && <ConfirmDialog { ...confirmDialogProps } /> }

			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(MfaSetup, 'mfaSetup');

